export default __webpack_public_path__ + "static/media/Panhead XPA - proportioned_170.63b9e60b.jpg";